var map = {
	"./bg-move-home.png": 4339,
	"./bg-move-r.png": 3098,
	"./bg-move.png": 75367,
	"./calidad.png": 80936,
	"./cloud-native_01.png": 35839,
	"./cloud-native_02.png": 15059,
	"./cloud-native_03.png": 81170,
	"./dexga.png": 50430,
	"./digital-onboarding_01.png": 64187,
	"./digital-onboarding_02.png": 58684,
	"./ds_01.png": 71463,
	"./ds_02.png": 34460,
	"./ds_03.png": 42182,
	"./ds_04.png": 30153,
	"./ds_05.png": 16132,
	"./dxtecalis.jpg": 52930,
	"./evento_01.jpg": 54923,
	"./favicon-144.jpg": 28557,
	"./favicon-ide.png": 42192,
	"./favicon-sig.png": 52970,
	"./favicon.ico": 41593,
	"./gatsby-astronaut.png": 19697,
	"./gatsby-icon.png": 54396,
	"./home1.jpg": 19483,
	"./home1.png": 45040,
	"./home2.jpg": 13536,
	"./home2.png": 99094,
	"./home3.jpg": 17456,
	"./home3.png": 34989,
	"./ic_decoration.svg": 41830,
	"./id_01.png": 64718,
	"./logo-tecalis-square.jpg": 82499,
	"./p_01.png": 13645,
	"./partner1.webp": 81314,
	"./partners.svg": 56257,
	"./people_01.png": 11370,
	"./people_02.png": 60368,
	"./people_03.png": 79156,
	"./people_04.png": 62670,
	"./people_05.png": 19980,
	"./policy--img.jpg": 35987,
	"./politicas.jpg": 83484,
	"./prescriptor.png": 66383,
	"./proveedores.png": 37088,
	"./reseller.png": 25972,
	"./rpa_01.png": 4566,
	"./rs-empresarial_01.jpg": 38892,
	"./rs-empresarial_01.png": 22778,
	"./rs-empresarial_02.png": 50500,
	"./rs-empresarial_03.png": 1353,
	"./rs-empresarial_04.svg": 21483,
	"./rs-empresarial_05.png": 84806,
	"./sge_01.png": 65834,
	"./sge_02.png": 21703,
	"./sig_01.png": 9605,
	"./sobre-tecalis_01.png": 54077,
	"./sobre-tecalis_02.png": 13033,
	"./sobre-tecalis_03.png": 74213,
	"./sobre-tecalis_04.png": 97300,
	"./tecalis-students_01.png": 76611,
	"./tecalis-students_02.png": 85897,
	"./tecalis-students_03.png": 6562,
	"./tecalis-students_04.png": 78419,
	"./tecalis-students_05.png": 23201,
	"./tecalis-students_06.png": 64449,
	"./tecalis-students_07.png": 98760,
	"./techinsights_bg.png": 82467,
	"./why-tecalis_01.png": 50397,
	"./why-tecalis_02.png": 43052,
	"./why-tecalis_03.png": 89871,
	"./why-tecalis_04.png": 53786,
	"./why-tecalis_logo-orange.png": 23850,
	"./why-tecalis_team.png": 29545,
	"./wt_01.png": 80992
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 96303;